import { isEmpty } from "@swiggy-private/js-utils";

export const isNewRelicAvailable = (): boolean => typeof window !== "undefined" && !!window.newrelic;

export const isNetworkError = (err: unknown): err is TypeError =>
    err instanceof TypeError &&
    /The internet connection appears to be offline|Failed to fetch|Load failed|Network request failed|NetworkError when attempting to fetch resource|The network connection was lost/i.test(
        err.message,
    );

export const isConnectionError = (err: unknown): err is TypeError =>
    err instanceof TypeError &&
    /Could not connect to the server|Remote server closed the connection before sending response header|Remote host closed connection during handshake/i.test(
        err.message,
    );

export const isAbortError = (err: unknown): err is DOMException => err instanceof Error && err.name == "AbortError";

export const captureError = (err: unknown): void => {
    // Defensive: error may be null/undefined due to cross-origin scripts or bad Promise rejections
    let errorObj;
    if (err instanceof ErrorEvent) {
        if (err.error instanceof Error) {
            errorObj = err.error;
        } else {
            // Handle null/undefined error and add context
            const message =
                err.message || "Script error." + (err.filename ? ` at ${err.filename}:${err.lineno}:${err.colno}` : "");
            errorObj = new Error(message);
        }
    } else {
        const error = (err as { reason?: unknown })?.reason;
        if (error instanceof Error) {
            errorObj = error;
        } else if (error === null || error === undefined) {
            errorObj = new Error("Promise rejected with null/undefined");
        } else {
            errorObj = new Error(String(error));
        }
    }
    const headers = window.__headers__;
    const newrelic = window.newrelic;
    if (newrelic && !isEmpty(headers)) {
        newrelic.noticeError(errorObj, {
            deviceId: headers["deviceid"] || "",
            sid: headers["sid"] || "",
            platform: headers["platform"] || "",
            userId: headers["userid"] || "",
            versionCode: headers["version-code"] || "",
            appVersionCode: headers["app-version"] || "",
            userAgent: headers["user-agent"] || "",
            xChannel: headers["x-channel"] || "",
        });
    }
};
